/*
  Tootelehe sisutabid — kaks mobiiliparandust (04.09.2026, kliendi raport).

  Tabid on RAADIONUPUD ilma JS-ita (vt snippets/product-tabs.liquid): peidetud
  `input[type=radio]` + label + paneel, ja CSS näitab paneeli reegliga
  `:checked + .product-tabs__tab + .product-tabs__panel`. Lauaarvutil on see
  täpselt õige — tabiribal ON alati üks tab valitud. Mobiilis on sama markup
  akordion, ja seal andis raadionupp kaks viga:

  1. „Tootest on alguses lahti ja ei saa kinni panna." Raadionuppu ei saa
     lahti klõpsata — see on tema definitsioon. Akordionilt oodatakse
     vastupidist.

  2. „Kui avada Koostis, teksti lõppu kerida ja valida Kasutamine, siis viskab
     rituaalide peale." See ei ole menüü ega rituaalide viga: „Koostis" on
     lehe pikim paneel, ja kui ta ALLPOOL asuvale tabile vajutades kokku
     tõmbub, kaob kerimispositsiooni KOHALT mitu tuhat pikslit sisu. Brauser
     hoiab `scrollY` muutumatuna, seega vaade maandub sama palju allpool —
     tootelehel on tabide järel `ritual-picker`, ja just sinna ta kukkus.

  Lahendus mõlemale on üks lühike kuulaja, mitte uus markup — nii jäävad
  nooleklahvid, fookus ja `:checked`-põhine CSS puutumata, ja ilma JS-ita
  töötab plokk endiselt (lihtsalt vana moodi).

  KUULAJA ON DOKUMENDI PEAL, mitte konteineril: tabe renderdatakse kahest
  kestast (`sections/product-tabs.liquid` ja `main-product`-i plokk
  `taramar_tabs`) ja Theme Editor võib sektsiooni igal hetkel uuesti
  renderdada. Delegeerimine üle elab selle ilma uuesti sidumata.
*/
(function () {
  'use strict';

  var ACCORDION = '(max-width: 749px)';

  function isAccordion() {
    return window.matchMedia(ACCORDION).matches;
  }

  function inputOf(label) {
    return label.control || document.getElementById(label.htmlFor);
  }

  document.addEventListener(
    'click',
    function (event) {
      var label = event.target.closest && event.target.closest('.product-tabs__tab');
      if (!label) return;

      var input = inputOf(label);
      if (!input) return;

      /*
        „Enne" tuleb mõõta SIIN, sest label'i klõps on veel oma faasis ja
        raadionupu vahetus on alles selle klõpsu vaikimisi tegevus — ta juhtub
        pärast seda, kui see funktsioon on lõpetanud. Seepärast käib „pärast"
        mõõtmine `requestAnimationFrame`-is.
      */
      var before = label.getBoundingClientRect().top;

      /*
        Lahti oleva rea uuesti vajutamine SULGEB ta — ainult akordionis.
        Lauaarvuti tabiribal jääb natiivne käitumine, sest seal tähendaks
        „kõik kinni" tühja riba ilma sisuta.

        `preventDefault()` on kohustuslik: ilma selleta märgiks brauseri oma
        vaikimisi tegevus raadionupu kohe uuesti valituks.
      */
      if (input.checked && isAccordion()) {
        event.preventDefault();
        input.checked = false;
      }

      /*
        `setTimeout(0)`, mitte `requestAnimationFrame`. Meil on vaja käivituda
        pärast klõpsu VAIKIMISI TEGEVUST (raadionupu vahetust), mitte pärast
        järgmist joonistust — ja `getBoundingClientRect()` sunnib paigutuse
        niikuinii värskeks, seega joonistust oodata ei ole vaja. Vahet on ka
        praktiline: rAF ei käivitu, kui leht ei joonista (peidetud kaart või
        paan), ja parandus jääks tegemata.
      */
      window.setTimeout(function () {
        var delta = label.getBoundingClientRect().top - before;
        if (delta) window.scrollBy(0, delta);
      }, 0);
    },
    false
  );

  /*
    Link mujalt lehelt, mis avab kindla tabi (11.10.2026): ostuveeru
    „Loe uuringust lähemalt" → `data-product-tab="teadus"`.

    Tabi id on `Tab-<nimi>-<uid>` ja uid tuleb sektsioonist, mida link ei tea —
    seepärast otsitakse algusega `Tab-<nimi>-`. Kui sellist tabi lehel ei ole
    (tootel puudub teadusetekst), jääb klõps puutumata ja lingi oma ankur
    (`#product-tabs`) teeb, mis suudab.

    Kerimine käib tabi SILDI juurde, mitte konteineri algusse: mobiilis on tabid
    akordion ja „Teadus" on neljas rida, seega konteineri algus näitaks kolme
    kinnist rida ja avatud sisu jääks ekraanist alla.
  */
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('[data-product-tab]');
      if (!link) return;

      var input = document.querySelector(
        '.product-tabs__input[id^="Tab-' + link.getAttribute('data-product-tab') + '-"]'
      );
      if (!input) return;

      event.preventDefault();
      input.checked = true;

      var label = document.querySelector('label[for="' + input.id + '"]') || input;
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      label.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });

      /* Klaviatuuriga tulija jätkab tabiribalt, mitte lingilt, kust ta lahkus. */
      input.focus({ preventScroll: true });
    },
    false
  );
})();
